import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { GetAllTierDTO } from "../../dto";

type GetAllTierProps = {
  page: number;
  pageSize: number;
  name?: string;
  createdOrder?: "ASC" | "DESC" | "";
  updatedOrder?: "ASC" | "DESC" | "";
};

let body: GetAllTierDTO;

export async function getAllTierAction(props: GetAllTierProps) {
  const token = localStorage.getItem("token");

  const params = {
    page: props.page,
    pageSize: props.pageSize,
    name: props.name,
    createdOrder: props.createdOrder !== "" ? props.createdOrder : undefined,
    updatedOrder: props.updatedOrder !== "" ? props.updatedOrder : undefined,
  };

  return await axios
    .get(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/tiers/get-all`, {
      headers: {
        "Content-Type": "application/json",
        "app-platform": "cms",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then(async (res) => {
      body = plainToClass(GetAllTierDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
